<template>
  <div class="shop">
    <div class="top" style="margin-bottom:10px">
      <el-input
        class="search-data"
        size="small"
        v-model="form.mobile"
        placeholder="搜索店铺手机号"
        clearable
      ></el-input>
      
      <el-button class="search" size="small" type="primary" @click="searchList"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="tableData"
      max-height="720"
      :cell-style="tc"
      :header-cell-style="tccolor"
    >
      <el-table-column label="序号" prop="id"></el-table-column>
      <el-table-column label="店铺账号" prop="mobile"></el-table-column>
      <el-table-column label="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="toCheck(scope.row.id)"
            >商品管理</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24">
      <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="form.page"
          :page-size="form.size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-col>
  </div>
</template>

<script>
import { getFreeManage } from '@/api/managent'
import { API_BASE_URL } from '@/config'
export default {
  components: {},
  data() {
    return {
      tableData: [],
      labelPosition: 'right',
      is_export: 0, //0非导出，1导出
      form: {
        mobile:'',
        page: 1,
        size: 10
      },
      total: 0
    }
  },
  mounted() {
    this.getManageList()
  },
  methods: {
    //获取列表数据
    async getManageList() {
      let is_export = this.is_export
      let url = `mobile=${this.form.mobile}&page=${this.form.page}&size=${
        this.form.size
      }&is_export=${is_export}`
      let res = await getFreeManage(url)
      console.log(res)
      if (res.code === 10000) {
        if (this.is_export == 1) {
          this.is_export = 0
          window.open(
            `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
          )
          return
        } else {
          this.tableData = res.data.data
          this.total = res.data.total
        }
      } else {
        this.$message.error(res.message)
      }
    },
    //搜索
    searchList() {
      this.is_export = 0
      this.form.page = 1
      this.getManageList()
    },
    // 分页设置
    pageChange(page) {
      this.form.page = page
      //获取更多数据
      this.getManageList()
    },
    // 查看详情
    toCheck(id) {
      this.$router.push({
        path: './freeGoodsEdit',
        query: { id: id }
      })
    },

    tc() {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor() {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>
<style lang="scss" scoped>
.shop {
  padding: 20px;
  .pagination {
    float: right;
    margin-top: 12px;
  }
  .top {
    .search-data {
      width: 150px;
      height: 32px;
      margin-right: 10px;
    }
  }
  ::v-deep.el-input--mini .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
  .align {
    text-align: center;
    padding-bottom: 20px;
  }
  .demo-ruleForm {
    padding: 20px;
    .remarkarea {
      padding-right: 30px;
      margin-top: 20px;
    }
  }
}
</style>
